import {useVentrataClient} from 'hooks/useVentrataClient'
import {useCallback} from 'react'
import {Params, Ventrata} from 'types'
import {ORDER_HEADERS} from './orderHeaders'

export const useApplyVoucherCodeApiMethod = () => {
  const ventrata = useVentrataClient()

  return useCallback(
    async ({order, code}: Params.ApplyDiscountCode) => {
      const {data} = await ventrata.patch<Ventrata.Order>(
        `/orders/${order.id}`,
        {giftPayment: {code}},
        {headers: ORDER_HEADERS}
      )

      return data
    },
    [ventrata]
  )
}
